/* import __COLOCATED_TEMPLATE__ from './pix-select.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let PixSelect = (_class = class PixSelect extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "elementHelper", _descriptor, this);
    _initializerDefineProperty(this, "isExpanded", _descriptor2, this);
    _initializerDefineProperty(this, "searchValue", _descriptor3, this);
    this.searchId = 'search-input-' + guidFor(this);
    this.selectId = this.args.id ? this.args.id : 'select-' + guidFor(this);
    this.listId = `listbox-${this.selectId}`;
    if (!this.args.isComputeWidthDisabled) {
      this.elementHelper.waitForElement(this.listId).then(elementList => {
        const baseFontRemRatio = Number(getComputedStyle(document.querySelector('html')).fontSize.match(/\d+(\.\d+)?/)[0]);
        const listWidth = elementList.getBoundingClientRect().width;
        const selectWidth = listWidth / baseFontRemRatio;
        const element = document.getElementById(`container-${this.selectId}`);
        element.style.setProperty('--pix-select-width', `${selectWidth}rem`);
      });
    }
  }
  get displayDefaultOption() {
    return !this.searchValue && !this.args.hideDefaultOption;
  }
  get className() {
    const classes = ['pix-select-button'];
    if (this.args.className) {
      classes.push(this.args.className);
    }
    if (this.args.errorMessage) {
      classes.push('pix-select-button--error');
    }
    return classes.join(' ');
  }
  get isAriaExpanded() {
    return this.isExpanded ? 'true' : 'false';
  }
  get placeholder() {
    if (!this.args.value) return this.args.placeholder;
    const option = this.args.options.find(option => option.value === this.args.value);
    return option ? option.label : this.args.placeholder;
  }
  get defaultOption() {
    return {
      value: ''
    };
  }
  toggleDropdown(event) {
    if (this.isExpanded) {
      this.hideDropdown(event);
    } else {
      this.showDropdown(event);
    }
  }
  showDropdown(event) {
    event.preventDefault();
    if (this.args.isDisabled) return;
    this.isExpanded = true;
  }
  hideDropdown(event) {
    if (this.isExpanded) {
      event.preventDefault();
      this.isExpanded = false;
    }
  }
  onChange(option, event) {
    if (this.args.isDisabled) return;
    this.args.onChange(option.value);
    this.hideDropdown(event);
    document.getElementById(this.selectId).focus();
  }
  setSearchValue(event) {
    if (this.args.onSearch) {
      this.args.onSearch(event.target.value);
      return;
    }
    this.searchValue = event.target.value.trim();
  }
  lockTab(event) {
    if (event.code === 'Tab' && this.isExpanded) {
      event.preventDefault();
      if (this.args.isSearchable) document.getElementById(this.searchId).focus();
    }
  }
  focus(event) {
    if (!event.target) return;
    if (!this.isExpanded) return;
    if (this.args.value) {
      event.target.querySelector("[aria-selected='true']")?.focus();
    } else if (this.args.isSearchable) {
      event.target.querySelector(`#${this.searchId}`)?.focus();
    } else if (this.displayDefaultOption) {
      event.target.querySelector("[aria-selected='true']")?.focus();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "elementHelper", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isExpanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "searchValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "toggleDropdown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleDropdown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDropdown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showDropdown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideDropdown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hideDropdown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSearchValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSearchValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lockTab", [action], Object.getOwnPropertyDescriptor(_class.prototype, "lockTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focus"), _class.prototype), _class);
export { PixSelect as default };